import { fetchRoleListApi, deleteRoleById, getRoleById, getAllModules } from "./roleApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchRoles = createAsyncThunk(
  "api/Role/get-role-list",
  fetchRoleListApi
);

